import { ACCOUNT_COLUMNS, FEEDBACK_COLUMNS } from '@/types/filterKeyConst';
import { CONTACT_COLUMNS } from '@/types/filterKeyConst';
import { ConstMap } from '@/utils/ConstMap';

export type ExtendedFilterQueryFormatT = StructuredFilterQueryFormatT & {
  domain: string | null;
  columnName: string;
};

export type SelectableItemT = {
  value: StringNumberValue;
  label: string;
  action: () => void;
};

export enum SEARCH_TARGET {
  DEFAULT = 'default',
  ACCOUNT = ACCOUNT_COLUMNS.ALIAS,
  CONTACT = CONTACT_COLUMNS.ALIAS,
  REMARKS = FEEDBACK_COLUMNS.REMARKS,
  TOPIC = FEEDBACK_COLUMNS.TAXONOMY_TOPIC,
}

export const SearchTargetNameMap = new ConstMap([
  [SEARCH_TARGET.DEFAULT, 'Text search'],
  [SEARCH_TARGET.ACCOUNT, 'Account name contains'],
  [SEARCH_TARGET.CONTACT, 'Contact name contains'],
  [SEARCH_TARGET.REMARKS, 'Remarks contains'],
  [SEARCH_TARGET.TOPIC, 'Topic name starts with'],
]);
